
// const items = Array.from(document.querySelectorAll('.search-results .init')) as HTMLElement[];

// items.forEach(item => {
//   const observer = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.intersectionRatio > 0) {
//         setTimeout(
//           () => entry.target.classList.remove('init'),  
//           entry.boundingClientRect.left / 2
//         );
//       }
//     })
//   });
//   observer.observe(item);
// });

const items = Array.from(document.querySelectorAll('.search-results .search-item')) as HTMLElement[];
const list  = document.querySelector('.search-results') as HTMLElement;


function resize() {

  const viewportWidth = document.documentElement.clientWidth;
  const adElement     = document.querySelector('.ad-item') as HTMLElement;
  const items         = Array.from(document.querySelectorAll('.search-results .search-item')) as HTMLElement[];

  // Fillers
  const tilesPerRow =
    viewportWidth >= 1175 ? 5 : 
    viewportWidth >=  948 ? 4 : 
    viewportWidth >=  719 ? 3 : 
    viewportWidth >=  491 ? 2 : 
    /*else*/ 1;
  

  const fillerAmount =
    items.length % tilesPerRow > 0 ?
      tilesPerRow - (items.length % tilesPerRow) : 
      /*else*/ 0;

  const fillers = Array.from(document.querySelectorAll('.filler')) as HTMLElement[];
  fillers.forEach(item => list.removeChild(item));

  for(let i=0; i<fillerAmount; i++) {
    const li = document.createElement('li');
    li.classList.add('filler');
    li.classList.add('search-item');
    list.appendChild(li);
  }



  // Add Element


  const newItems = Array.from(document.querySelectorAll('.search-results .search-item')) as HTMLElement[];

  let lastItem: HTMLElement;
  if (viewportWidth >= 1175 || viewportWidth < 719) {
    lastItem =
      newItems.length > 10 ? newItems[9] :
      /*else*/            newItems[newItems.length -1];
  }
  if (viewportWidth >= 719 && viewportWidth < 1175) {
    lastItem =
      newItems.length > 12 ? newItems[11] :
      /*else*/            newItems[newItems.length -1];
  }

  const html = `
    <li class="ad-item">
      <div class="search-result-ad-container">
        <div data-adtech="6531037"></div>
      </div>
    </li>
  `;

  if (!adElement) {
    lastItem.insertAdjacentHTML('afterend', html);
  }
  else {
    list.insertBefore(adElement, lastItem.nextElementSibling);
  }

}

window.onresize = resize;
resize();






